import axios from 'axios';

export async function heartBeat() {
  const response = await axios.get(
    `${process.env.NEXT_PUBLIC_API_URL}/healthz`,
  );
  return response.data;
}
